var castPath = require("./_castPath"), last = require("./last"), parent = require("./_parent"), toKey = require("./_toKey");
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}
module.exports = baseUnset;
